import { AiOutlineFacebook } from "react-icons/ai";
import { AiOutlineLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";

const data = [
  {
    id: 2,
    link: "https://www.facebook.com/rahul.keshri.5011",
    icon: <AiOutlineFacebook />,
  },
  {
    id: 3,
    link: "https://www.linkedin.com/in/rahul-keshri-814bb8221/",
    icon: <AiOutlineLinkedin />,
  },
  { id: 4, link: "https://github.com/keshri522", icon: <AiFillGithub /> },
];

export default data;
